
import React from 'react';
import { TicketType } from '../types';
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Pencil, Trash2 } from "lucide-react";

interface TicketListProps {
  tickets: TicketType[];
  onEdit: (ticket: TicketType) => void;
  onDelete: (id: string) => void;
}

const TicketList: React.FC<TicketListProps> = ({ tickets, onEdit, onDelete }) => {
  const formatCurrency = (price: number, currency: string) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency
    }).format(price);
  };

  return (
    <Table>
      <TableHeader>
        <TableRow className="hover:bg-white/5 border-b border-white/10">
          <TableHead className="text-white">Ticket</TableHead>
          <TableHead className="text-white">Price</TableHead>
          <TableHead className="text-white">Availability</TableHead>
          <TableHead className="text-white">Status</TableHead>
          <TableHead className="text-white w-[120px]">Actions</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {tickets.map((ticket) => (
          <TableRow key={ticket.id} className="hover:bg-white/5 border-b border-white/10">
            <TableCell className="font-medium text-white">
              <div className="flex flex-col">
                <span>{ticket.name}</span>
                <span className="text-xs text-gray-400">{ticket.description}</span>
              </div>
            </TableCell>
            <TableCell className="text-gray-300">
              {formatCurrency(ticket.price, ticket.currency)}
            </TableCell>
            <TableCell className="text-gray-300">
              <div className="flex flex-col">
                <span className="text-xs">From: {new Date(ticket.available_from).toLocaleDateString()}</span>
                <span className="text-xs">Until: {new Date(ticket.available_until).toLocaleDateString()}</span>
                {ticket.quantity && (
                  <span className="text-xs">{ticket.sold} / {ticket.quantity} sold</span>
                )}
              </div>
            </TableCell>
            <TableCell>
              <span className={`px-2 py-1 text-xs rounded-full ${
                ticket.active ? 'bg-green-500/40 text-green-100' : 'bg-gray-500/40 text-gray-100'
              }`}>
                {ticket.active ? 'Active' : 'Inactive'}
              </span>
            </TableCell>
            <TableCell>
              <div className="flex space-x-2">
                <Button 
                  variant="ghost" 
                  size="icon" 
                  onClick={() => onEdit(ticket)}
                  className="text-white hover:text-purple-400 hover:bg-white/10"
                >
                  <Pencil className="h-4 w-4" />
                </Button>
                <Button 
                  variant="ghost" 
                  size="icon"
                  onClick={() => ticket.id && onDelete(ticket.id)}
                  className="text-white hover:text-red-400 hover:bg-white/10"
                >
                  <Trash2 className="h-4 w-4" />
                </Button>
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default TicketList;
